'use strict';


export default function(handleRepeatedEvent) {
	this.timestampIncident = function(incident) {
		incident.timestamps = {};
		for (var entry of incident.log) {
			if (!incident.timestamps.hasOwnProperty(entry.event)) {
				incident.timestamps[entry.event] = entry;
			} else {
				switch(entry.event) {
					case 'geo:departed':
          case 'geo:left_geofence':
						incident.timestamps[entry.event] = entry;
						break;
				}
				if (handleRepeatedEvent) {
					handleRepeatedEvent(incident, entry);
				}
			}
		}
	}
}
